import InformationSecurityPolicy from './InformationSecurityPolicy';

export default InformationSecurityPolicy;
